<template>
	<div>
		<van-search v-model="searchValue" show-action placeholder="请输入搜索关键词" @input="input" />
		<div class="hh">
			<van-cell-group :border="false"><van-cell v-for="(dept, index) of deptList" :key="index" :title="dept.name" is-link @click="toDoctor(dept)" /></van-cell-group>
		</div>
	</div>
</template>

<script>
import { getDeptList } from '@/api/hdTCM';
export default {
	data() {
		return {
			activeKey: 0,
			searchValue: '', // 搜索值
			deptList: '' //科室列表
		};
	},
	created() {
		//初始化科室列表
		getDeptList({ name: '1' }).then(res => {
			if (res.success) {
				this.deptList = res.result;
			}
		});
	},
	methods: {
		input(val) {
			this.$toast(val);
		},

		toDoctor(v) {
			this.$router.push({ path: '/dept_detail', query: { code: v.code } });
		}
	}
};
</script>

<style scoped>
.hh {
	overflow-y: auto;
	overflow-x: hidden;
	position: fixed;
	height: 90%;
	width: 100%;
}
</style>
